var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.083 17.45a.922.922 0 01-.337-.063.812.812 0 01-.288-.188l-4.175-4.175a.694.694 0 01-.213-.537.836.836 0 01.213-.537c.15-.15.33-.225.538-.225.208 0 .38.075.512.225l3.75 3.75 8.65-8.65a.669.669 0 01.525-.226c.217 0 .392.075.525.225.15.15.225.33.225.537a.734.734 0 01-.225.538L10.708 17.2a.814.814 0 01-.287.188.93.93 0 01-.338.063z",
    fill: "currentColor"
  })));
}
export default SvgCheckmarkLight;